import React from 'react';
interface ChampionLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qx5Lg8aAYGUHHWyYpDu3qx/ChampionLogo_GDI_Primary.png';
export function ChampionLogo({
  size = 'md',
  variant = 'dark'
}: ChampionLogoProps) {
  const isLight = variant === 'light';
  const sizeClasses = {
    sm: 'h-8 md:h-10',
    md: 'h-10 md:h-14',
    lg: 'h-14 md:h-18'
  };
  return <div className="flex flex-col" data-id="element-960">
      <img src={LOGO_URL} alt="Champion Windows - Sunrooms - Home Exteriors" className={`${sizeClasses[size]} w-auto object-contain ${isLight ? '' : 'brightness-[0.85] contrast-[1.2]'}`} draggable={false} data-id="element-961" />
    </div>;
}